import { get } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Formik, Form } from "formik";

import * as Yup from "yup";
import * as Schemas from "../forms/validationSchemas.js";

import ValidationMessage from "../forms/messages/ValidationMessage.jsx";
import SegmentMessage from "../forms/messages/SegmentMessage.jsx";
import FormikConfirmedPasswordInput from "../forms/formik/FormikConfirmedPasswordInput.jsx";
import FormikActionsPanel from "../forms/formik/FormikActionsPanel.jsx";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class PasswordResetForm extends PureComponent {
  static propTypes = {
    isFetching: PropTypes.bool.isRequired,
    isError: PropTypes.bool.isRequired,
    errorMessage: PropTypes.object,
    onReset: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    isFetching: false,
    isError: false
  };

  constructor(props) {
    super(props);

    this.state = {
      showMessages: false
    };

    this.initialValues = {
      password: "",
      passwordConfirmation: ""
    };
  }

  // -- VALIDATION -- //

  validationSchema = function () {
    const messages = this.props.copy("forms.validation_requirements");

    return Yup.object().shape({
      password: Schemas.passwordSchema("Password", messages, true),
      passwordConfirmation: Schemas.passwordConfirmationSchema(
        "Confirm Password",
        messages,
        true
      )
    });
  };

  // -- HANDLERS -- //

  onReset = () => {
    this.setState({ showMessages: false });
    this.props.onReset();
  };

  onSubmit = () => {
    this.setState({ showMessages: true });
  };

  // only triggered whenever the submit button is clicked and the form is valid
  onFormikSubmit = values => {
    this.props.onSubmit(values);
  };

  // -- RENDER -- //

  renderErrorMessage = formikProps => {
    const { isFetching, isError, errorMessage, violationErrors } = this.props;
    const { showMessages } = this.state;

    if (isFetching) return null;

    if (isError && errorMessage) {
      return (
        <SegmentMessage
          title={errorMessage.title}
          message={errorMessage.message}
          negative={true}
        />
      );
    }

    const valid =
      formikProps.isValid && !this.props.violationErrors ? true : false;

    if (showMessages) {
      return <ValidationMessage valid={valid} />;
    }

    return null;
  };

  render() {
    const { validationMessages } = this.props;

    return (
      <Formik
        initialValues={this.initialValues} // required by semantic-ui react
        isInitialValid={false}
        validationSchema={this.validationSchema()}
        onSubmit={this.onFormikSubmit}
      >
        {formikProps => {
          return (
            <Form className="ui form">
              {this.renderErrorMessage(formikProps)}

              <FormikConfirmedPasswordInput apiErrors={validationMessages} />
              <FormikActionsPanel
                reset={true}
                onReset={this.onReset}
                submit={true}
                useSubmitModal={true}
                onSubmit={this.onSubmit}
              />
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const mapStateToProps = state => ({
  isError: state.password.isErrored,
  errorMessage: get(state, "errors.errorMessages[0]", null),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(PasswordResetForm);
